import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import {
  fetchAuthSession,
  getCurrentUser,
  signIn,
  signOut,
} from 'aws-amplify/auth';
import { Amplify } from 'aws-amplify';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

interface UserProfile {
  email: string;
  nombre: string;
  apellido: string;
}

export interface IUser {
  email: string;
  password: string;
  name: string;
}
@Injectable({
  providedIn: 'root',
})
export class CognitoService {
  private authenticationSubject: BehaviorSubject<any>;
  constructor(private router: Router) {
    Amplify.configure({
      Auth: {
        Cognito: {
          userPoolId: environment.cognito.userPoolId,
          userPoolClientId: environment.cognito.userPoolWebClientId,
        },
      },
    });

    this.authenticationSubject = new BehaviorSubject<boolean>(false);
  }

  public async signIn(user: IUser): Promise<any> {
    const username = user.email;
    const password = user.password;

    try {
      const user = await signIn({ username, password });
      this.getProfileUSer();
      return user;
    } catch (error) {
      console.error('Error al iniciar sesión:', error);
      throw error;
    }
  }


  public async signOut(): Promise<any> {
    await signOut();
    localStorage.removeItem('email');
    localStorage.removeItem('apellido');
    localStorage.removeItem('nombre');
    localStorage.removeItem('theme');
    this.authenticationSubject.next(false);
    this.router.navigate(['/auth']);
  }

  public isAuthenticated(): Promise<boolean> {
    if (this.authenticationSubject.value) {
      return Promise.resolve(true);
    } else {
      return this.getUser()
        .then((user: any) => {
          if (user) {
            return true;
          } else {
            return false;
          }
        })
        .catch(() => {
          return false;
        })

        .then((userAuthenticated) => {
          if (userAuthenticated) {
            return this.getRol().then((rolValue) => {
              if (
                rolValue[0] === 'ADMIN_ADMINISTRACION' ||
                rolValue[0] === 'ACCESS_DEV'
              ) {
                return true;
              } else {
                return false;
              }
            });
          } else {
            return false;
          }
        });
    }
  }

  public async getUser(): Promise<any> {
    return await getCurrentUser();
  }

  public async getProfileUSer(): Promise<UserProfile> {
    const userAuthInfo = await fetchAuthSession();

    const email = String(
      userAuthInfo?.tokens?.idToken?.payload['cognito:username'] ?? ''
    );
    const apellido = String(
      userAuthInfo?.tokens?.idToken?.payload['family_name'] ?? ''
    );
    const nombre = String(
      userAuthInfo?.tokens?.idToken?.payload['middle_name'] ?? ''
    );

    localStorage.setItem('email', email);
    localStorage.setItem('apellido', apellido);
    localStorage.setItem('nombre', nombre);

    return { email, apellido, nombre };
  }

  public async getRol(): Promise<any> {
    const userAuthInfo = await fetchAuthSession();
    return userAuthInfo?.tokens?.idToken?.payload['cognito:groups'];
  }

  public async getToken(): Promise<any> {
    const session = await fetchAuthSession();
    const idToken = session.tokens?.idToken?.toString() ?? null;
    return idToken;
  }

  public async getSession(): Promise<any> {
    return await fetchAuthSession();
  }
}
